import { TableCell, TableSortLabel } from '@mui/material';
import type { ReactNode } from 'react';

import type { SortStateType } from './useSort';

type SortableCellProps<TKey extends string> = {
  sort: SortStateType<TKey>;
  column: TKey;
  align?: 'left' | 'center' | 'right';
  children: ReactNode;
};

/**
 * A header cell that sorts. The same six lines were written out per column per page, and the pages that
 * had not written them offered no sorting at all (R0141).
 */
export const SortableCell = <TKey extends string>({
  sort,
  column,
  align,
  children,
}: SortableCellProps<TKey>) => (
  <TableCell align={align} sortDirection={sort.key === column ? sort.direction : false}>
    <TableSortLabel
      active={sort.key === column}
      direction={sort.key === column ? sort.direction : 'asc'}
      onClick={() => sort.toggle(column)}
    >
      {children}
    </TableSortLabel>
  </TableCell>
);
